import { ChangeDetectionStrategy, Component, Input, SimpleChanges } from '@angular/core';
import * as Highcharts from 'highcharts';
import variablePie from 'highcharts/modules/variable-pie';
import HC_accessibility from 'highcharts/modules/accessibility';
import { HttpClient } from '@angular/common/http';
import { PiechartService } from '../../piechart.service';
import { Observable, Subscription } from 'rxjs';
import { SnapshotService } from 'src/app/modules/snapshot/Services/snapshot.service';
import { COMMON_CONSTANTS, COMMON_CONSTANTS_Percentage, COMMON_CONSTANTS_SNAPSHOT } from 'src/app/common/constants/common-constants';

@Component({
  selector: 'app-piechart12',
  templateUrl: './piechart12.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Piechart12Component {
  constructor(
    private http: HttpClient,
    private piechartservice: PiechartService,
    private _configService: SnapshotService
  ) { }
  jsondata: any;
  seriescolor: any;
  seriesgradientcolor: any;
  chartproperties: any;
  samplesizeconstant: any;
  chartimagepath: any;
  significanceValue: any = "None";
  @Input() id: any;
  @Input() height: any = '44%';
  @Input() data: any;
  Sig_LowerLimt = COMMON_CONSTANTS.SigLowerLimit_95;
  Sig_UpperLimt = COMMON_CONSTANTS.SigUpperLimit_95;
  DefaultConfidenceLevel: any = "";
  private subscriptions: Subscription = new Subscription();

  ngOnInit(): void {
    this.subscriptions.add(
      this._configService.confedenceValue.subscribe(value => {
        this.DefaultConfidenceLevel = value;
        this.updateSig();
      }));
    this.subscriptions.add(
      this._configService.significanceValue.subscribe(value => {
        this.significanceValue = value;
        this.updateSig();
      }));

  }

  ngOnChanges(changes: SimpleChanges) {
    this.updateSig();
  }

  // ngAfterViewInit(){
  //   this.plotChart('chart-container', this.jsondata['data'], this.chartproperties);
  // }

  updateSig() {
    this.subscriptions.add(
      this.http.get<any>('assets/Data/piechart.json').subscribe((data) => {
        this.jsondata = data[0];
        this.chartproperties = this.jsondata['properties'][0];
        this.seriescolor = this.piechartservice.color;
        this.chartimagepath = this.piechartservice.chartimagepath;
        this.seriesgradientcolor = this.piechartservice.linearGradients1;
        this.samplesizeconstant = this.piechartservice.samplesizeconstant;
        this.chartproperties.datalabelStyle = this.significanceValue == "None" ? "datalabel" : "sigChange";
        this.chartproperties.datalabelStyle = this._configService.isIndexSelected ? "index" : this.chartproperties.datalabelStyle;


        //Add this code if confidence level none is req
        // : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_None
        //         ? COMMON_CONSTANTS.SigLowerLimit_99
        this.Sig_LowerLimt =
          this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_95
            ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_95
            : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_90
              ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_90
              : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_99
                ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_99
                : COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_95;
        this.Sig_UpperLimt =
          this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_95
            ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_95
            : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_90
              ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_90
              : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_99
                ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_99
                : COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_95;
        this.plotChart('chart-container' + this.id, this.jsondata['data'], this.chartproperties);
      }));
  }

  ngOnChnages() {
    this.legendCounter = 0;
    this.plotChart('chart-container' + this.id, this.jsondata['data'], this.chartproperties);
  }

  customization(): Observable<any[]> {
    return this.piechartservice.PieChart1to10customizationList();
  }
  seriesdata: any;
  cov: any;
  significance: any;
  samplesize: any;
  label: any;
  datalength: number = 0;

  chartMainData: any = []
  mdsData: any = [];
  legendCounter = 0;
  datacopy: any = [];
  preparemainChartData(data: any) {
    this.chartMainData = [];
    let i = this.legendCounter;
    
    let meaningful = data.find((d: any) => d.submetricName == "Meaningful")?.metricSelected?.metrics[0]?.data[0].data == undefined ? 0 : data.find((d: any) => d.submetricName == "Meaningful")?.metricSelected?.metrics[0]?.data[0].data;
    let difference = data.find((d: any) => d.submetricName == "Different")?.metricSelected?.metrics[0]?.data[0].data == undefined ? 0 : data.find((d: any) => d.submetricName == "Different")?.metricSelected?.metrics[0]?.data[0].data;
    let salience = data.find((d: any) => d.submetricName == "Salience")?.metricSelected?.metrics[0]?.data[0].data == undefined ? 0 : data.find((d: any) => d.submetricName == "Salience")?.metricSelected?.metrics[0]?.data[0].data;

    let meaningfulIndex = data.find((d: any) => d.submetricName == "Meaningful")?.metricSelected?.metrics[0]?.data[0].data2 == undefined ? 0 : data.find((d: any) => d.submetricName == "Meaningful")?.metricSelected?.metrics[0]?.data[0].data2;
    let differenceIndex = data.find((d: any) => d.submetricName == "Different")?.metricSelected?.metrics[0]?.data[0].data2 == undefined ? 0 : data.find((d: any) => d.submetricName == "Different")?.metricSelected?.metrics[0]?.data[0].data2;
    let salienceIndex = data.find((d: any) => d.submetricName == "Salience")?.metricSelected?.metrics[0]?.data[0].data2 == undefined ? 0 : data.find((d: any) => d.submetricName == "Salience")?.metricSelected?.metrics[0]?.data[0].data2;

    let data1: any = [];
    this.datacopy = JSON.parse(JSON.stringify(data));
    this.datacopy.forEach((d: any) => {
      if (d.submetricName == "Meaningful") {
        d.metricSelected.metrics.forEach((m: any) => {
          let actualVal = m.data[0].data;
          m.data[0].data = (m.data[0].data) / (meaningful + difference + salience) * 360;
          m.data[0].data2 = (m.data[0].data2) / (meaningfulIndex + differenceIndex + salienceIndex) * 360;

          if (actualVal == -1) {
            m.data[0].data = 0;
            m.data[0].data2 = 0;
          }

          m.samplesize = m.data[0].baseValueforLSorIs
          // m.data=150
          m.data = m.data
        })
        data1.push(d);
      }
      if (d.submetricName == "Different") {
        d.metricSelected.metrics.forEach((m: any) => {
          let actualVal = m.data[0].data;
          m.data[0].data = (m.data[0].data) / (meaningful + difference + salience) * 360;
          m.data[0].data2 = (m.data[0].data2) / (meaningfulIndex + differenceIndex + salienceIndex) * 360;
          if (actualVal == -1) {
            m.data[0].data = 0;
            m.data[0].data2 = 0;

          }
          m.samplesize = m.data[0].baseValueforLSorIs
          // m.data=101
          // m.data=m.data
        })
        data1.push(d);
      }
      if (d.submetricName == "Salience") {
        d.metricSelected.metrics.forEach((m: any) => {
          let actualVal = m.data[0].data;
          m.data[0].data = (m.data[0].data) / (meaningful + difference + salience) * 360;
          m.data[0].data2 = (m.data[0].data2) / (meaningfulIndex + differenceIndex + salienceIndex) * 360;

          if (actualVal == -1) {
            m.data[0].data = 0;
            m.data[0].data2 = 0;

          }
          m.samplesize = m.data[0].baseValueforLSorIs
          // m.data=m.data
          // m.data=101
        })
        data1.push(d);
      }

    })
    
    this.mdsData = this.data;
    data1.forEach((lev1: any) => {
      lev1.metricSelected.metrics.forEach((lev2: any) => {
        lev2.data.forEach((dataArr: any) => {
          let d1 = {
            "Series Name": lev2.metricName,
            "Category Name": lev1.submetricName,
            "Rounded Value": dataArr.CalculationType === "share" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "Value": dataArr.CalculationType.toLowerCase() == "share" || dataArr.CalculationType.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "ValueForIndex": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "Label": dataArr.CalculationType.toLowerCase() == "share" || dataArr.CalculationType.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "Change value vs PY": dataArr.changeVsPY,
            "Significance": "-1",
            "Sample size": dataArr.baseValueforLSorIs,
            "Significance2": "1",
            "isPercentage": dataArr.CalculationType.toLowerCase() == "share" || dataArr.CalculationType.toLowerCase() == "respgrp" ? true : false,
            Sig_LowerLimt: this.Sig_LowerLimt,
            Sig_UpperLimt: this.Sig_UpperLimt,
            significanceValue: this.significanceValue,
            Significance_Value: dataArr.Significance_Value
          }
          this.chartMainData.push(d1);
        });
      });
    })
  }
  preparechartdata(data: any, islowsample: boolean, isgradient: boolean) {
    let seriesdata: any[] = [];
    let d: any = {};
    let cov: any = [];
    let significance: any = [];
    let samplesize: any = [];
    let label: any = [];
    let i = 0;
    let mdsdata = this.mdsData;
    d.sizeBy = 'radius',
      d.animation = this.piechartservice.allowAnimation;
    d.data = [];
    let datacopy: any = JSON.parse(JSON.stringify(data));
    datacopy.forEach((dat: any) => {
      cov.push(dat['Change value vs PY']);
      significance.push(dat['Significance']);
      samplesize.push(dat['Sample size']);
      label.push(dat['Label']);
      d.name = dat['Category Name'];
      let value = isNaN(parseFloat(dat['Rounded Value'])) || parseFloat(dat['Rounded Value']) == null ? null : Number(parseFloat(dat['Value']).toFixed(this.chartproperties.decimalRoundOff))
      let finalvalue = !islowsample ? value : (parseFloat(dat['Sample size']) > this.samplesizeconstant ? value : 0)
      let m = {
        name: dat['Series Name'],
        y: (this._configService.userRole != "superadmin" && Number(dat['Sample size']) <= this._configService.ISthreshold ? 0 : (finalvalue == null ? 0 : finalvalue)),
        indexValue: (this._configService.userRole != "superadmin" && Number(dat['Sample size']) <= this._configService.ISthreshold ? 0 : (dat['ValueForIndex'] == null ? 0 : dat['ValueForIndex'])),
        y1: finalvalue,
        actualcolor: this.seriescolor[i],
        color: !isgradient ? this.seriescolor[i++] : this.seriesgradientcolor[i++],
        z: parseFloat(dat['Rounded Value']),
        zmax: parseFloat(dat['Rounded Value']) + 50,
        zmin: 0,
        cov: dat['Change value vs PY'],
        significance: dat['Significance'],
        significance2: dat['Significance2'],
        samplesize: dat['Sample size'],
        tooltip: "",
        isPercentage: dat["isPercentage"],
        Sig_LowerLimt: this.Sig_LowerLimt,
        Sig_UpperLimt: this.Sig_UpperLimt,
        significanceValue: this.significanceValue,
        Significance_Value: dat.Significance_Value
      };
      d.data.push(m);
      this.datalength++;
    });
    seriesdata = [d];
    d = {};
    this.cov = cov;
    this.significance = significance;
    this.samplesize = samplesize;
    this.label = label;
    this.seriesdata = seriesdata;
  }
  chart: any;
  plotChart(containerId: any, jsondata: any, chartproperties: any) {

    let i = 1;
    localStorage.setItem("properties", JSON.stringify(this.chartproperties));
    HC_accessibility(Highcharts);
    variablePie(Highcharts);
    let c = 0
    let chartimagepath = this.chartimagepath;
    let samplesizeconstant = this.samplesizeconstant;
    this, this.chartMainData = []
    this.preparemainChartData(this.data);
    let height = this.height;
    this.preparechartdata(this.chartMainData, chartproperties.datalabelStyle == 'ls', chartproperties.gradientBarColor);
    let mdsdata = this.mdsData;
    let chartmaindata = this.chartMainData;
    let seriesdata = this.seriesdata;
    let dataLength = seriesdata[0].data.length;

    const configService = this._configService;

    this.chart = Highcharts.chart(containerId, {
      accessibility: {
        point: {
          valueSuffix: '%'
        }
      },
      chart: {
        // marginBottom:90,
        type: 'variablepie',
        contextMenu: false,
        backgroundColor: chartproperties.darkTheme ? '#333' : 'white',
        events: {
          render: function () {
            if (seriesdata.length > 0) {
              var chart = this as any,
                maxZ = Math.max.apply(Math, chart.series[0].data.map(function (point: any) { return point.z; })),
                minZ = Math.min.apply(Math, chart.series[0].data.map(function (point: any) { return point.z; })),
                series = chart.series[0],
                maxRadius = series.points.reduce(function (max: any, point: any) {
                  return Math.max(max, point.shapeArgs.r);
                }, 0),

                minRadius = series.points.reduce(function (min: any, point: any) {
                  return Math.min(min, point.shapeArgs.r);
                }, Infinity);

              let minInnerRadius = series.points.reduce(function (min: any, point: any) {
                return Math.min(min, point.shapeArgs.innerR);
              }, Infinity);


              // Calculate radius for z=100
              var radiusForZ100;
              if (minZ > 100) {
                radiusForZ100 = minInnerRadius - 5; // Adjust this value as needed to make it slightly less than minRadius
              } else {
                radiusForZ100 = (100 - minZ) / (maxZ - minZ) * (maxRadius - minRadius) + minRadius;
              }


              //var radiusForZ100 = (100 - minZ) / (maxZ - minZ) * (maxRadius - minRadius) + minRadius;
              


              // Clear existing dotted circle
              if (chart.dottedCircle) {
                chart.dottedCircle.destroy();
              }

              // Draw dotted circle
              let borderWidth = 1;
              let borderColor = chartproperties.darkTheme ? 'white' : '#333';
              chart.dottedCircle = chart.renderer.circle(chart.plotWidth / 2 + chart.plotLeft, chart.plotHeight / 2 + chart.plotTop, radiusForZ100)
                .attr({
                  zIndex: 6,
                  fill: 'none',
                  'stroke-width': borderWidth,
                  stroke: borderColor,
                  dashstyle: 'Dash',
                  display: chartproperties.innerBorder ? 'block' : 'none',
                })
                .add();
            }
          },


          load: function () {
            const chart = this as any;
            function updateCenterText() {
              if (seriesdata.length > 0) {
                let powervalue = Number.parseFloat(mdsdata.find((d: any) => d.submetricName == "Brand Power").metricSelected.metrics[0].data[0].data).toFixed(chartproperties.decimalRoundOff);
                powervalue = configService.CheckLSorIScondition(configService.userRole, Number.parseFloat(mdsdata.find((d: any) => d.submetricName == "Brand Power").metricSelected.metrics[0].data[0].data).toFixed(chartproperties.decimalRoundOff).toString(), Number(mdsdata.find((d: any) => d.submetricName == "Brand Power").metricSelected.metrics[0].data[0].baseValueforLSorIs));
                let centerX = chart.plotWidth / 2 + chart.plotLeft - (height != "100%" ? 25 / 2 : 60 / 2);
                let centerY = chart.plotHeight / 2 + chart.plotTop + 10 / 2;

                if (chart.centerText) {
                  chart.centerText.attr({
                    text: `<div class="center-text" style="text-align: center; font-size: ${height != '100%' ? '0.5em' : '1em'};"> Power<br>${powervalue}</div>`,
                    x: centerX,
                    y: centerY,
                    fontSize: height != '100%' ? '0.5em' : '1em'
                  });
                } else {
                  chart.centerText = chart.renderer.html(
                    `<div class="center-text" style="text-align: center; font-size: ${height != '100%' ? '0.5em' : '1em'};"> Power<br>${powervalue}</div>`,
                    centerX,
                    centerY
                  ).attr({
                    zIndex: 5,
                    fontSize: height != '100%' ? '0.5em' : '1em'
                  }).add();
                }
              }
            }

            updateCenterText();
            window.addEventListener('resize', function () {
              chart?.reflow();
              if (chart) { updateCenterText() };
            });

          }

        },
        style: {
          fontFamily: this.piechartservice.fontFamily,
          height: this.height !== "100%" ? '100%' : this.height
          // height:200
        }
      },
      title: {
        text: "",
        align: chartproperties.chartTitlePosition,
        verticalAlign: 'top',
        style: {
          color: chartproperties.darkTheme ? 'white' : 'black',
          fontSize: "2em"
        },
      },
      legend: {
        events: {
          itemClick: function (event: any) {
            event.preventDefault(); // Prevent the default action
            return false; // Further prevent the default action
          }
        },
        navigation: {
          enabled: false,
          // itemMarginLeft: 10,
          activeColor: '#7f7f7f',
          animation: true,
          arrowSize: 10,
          inactiveColor: '#ccc',
          style: {
            fontSize: '0.7em',
            color: chartproperties.darkTheme ? 'white' : '#333',
          }
        },
        y: chartproperties.legendPosition == 'bottom' ? 0 : 0,
        // maxHeight: chartproperties.legendPosition == 'bottom' ? 40 : 400,
        layout:
          chartproperties.legendPosition != 'bottom'
            ? 'vertical'
            : 'horizontal',
        align: chartproperties.legendPosition,
        verticalAlign:
          chartproperties.legendPosition != 'bottom' ? 'middle' : 'bottom',
        useHTML: true,
        // symbolWidth: chartproperties.legendStyle == 'default'?12:-1,
        // symbolRadius: chartproperties.legendStyle == 'default'?6:-1,
        // symbolHeight:chartproperties.legendStyle == 'default'?12:-1,
        symbolWidth: 0,  // Set to a valid non-negative value
        symbolHeight: 0, // Set to a valid non-negative value
        //symbolWidth: -1,
        //symbolHeight: -1,
        // itemMarginTop: 10,    // Adjust this value to reduce the top margin
        // itemMarginBottom: -5, 
        itemStyle: {
          fontWeight: "normal",
          fontSize: "0.8em",
          cursor: 'pointer'
        },
        animation: false,

        labelFormatter: function (): any {
          // ]\
          let limit = height == "100%" ? dataLength : dataLength;
          if (i > limit) { i = 1 }
          if (i == limit) {
            i = chartmaindata.length + 1;
            let point = this as any;
            let textcolor = chartproperties.darkTheme ? 'white' : 'black';
            // return '<div style="display:flex;align-items:center;font-size:0.8em;" title="' + point.name + '">'
            // + '<div style="display:flex;width:10px;height:10px;background-color:' + point.color + ';border-radius:50%"></div>'
            // + '<div style="width:70px;height:20px;padding-left:10px;padding-top:5px;color:'+textcolor+';overflow:hidden;white-space:nowrap;text-overflow:ellipsis;flex:1;" title="' + point.name + '">' + '   ' + point.name + '   '+ '</div>'
            // + '</div>'; 

            if (chartproperties.datalabelStyle === "index") {
              let premium = (mdsdata.find((d: any) => d.submetricName == "Brand Premium")) ? `<div style="display:flex;align-items: center;justify-content:center;flex-direction:column;height:100%;margin-top:5%;">
              <div style="display: flex; align-items: center;margin-bottom:4%;">
                <div style="width: 25px; height: 5px; background-color: #f3eaff; border-radius: 50%; display: flex; justify-content: center; align-items: center; margin-right: 10px;">
                  <img src="/assets/images/common/PremiumIndex_icon.svg" alt="icon" style="width: 24px; height: 24px;">
                </div>
                <div style="display: flex; flex-direction: column;min-width:85px">
                  <div style="font-size: 0.6rem; color: #333; font-weight: 500;">Premium Index</div>
                  <div style="font-size: 0.6rem; color: #000; font-weight: 700;">${configService.CheckLSorIScondition(configService.userRole, Number.parseFloat(mdsdata.find((d: any) => d.submetricName == "Brand Premium").metricSelected.metrics[0].data[0].data).toFixed(chartproperties.decimalRoundOff).toString(), Number(mdsdata.find((d: any) => d.submetricName == "Brand Premium").metricSelected.metrics[0].data[0].baseValueforLSorIs))}
                   <span style="color: ${configService.CheckIndexColoring(Number.parseFloat(
                mdsdata.find((d: any) => d.submetricName == "Brand Premium").metricSelected.metrics[0].data[0].data2
              ).toFixed(chartproperties.decimalRoundOff).toString())};">
                 (${configService.CheckLSorIScondition(
                configService.userRole,
                Number.parseFloat(
                  mdsdata.find((d: any) => d.submetricName == "Brand Premium").metricSelected.metrics[0].data[0].data2
                ).toFixed(chartproperties.decimalRoundOff).toString(),
                Number(
                  mdsdata.find((d: any) => d.submetricName == "Brand Premium").metricSelected.metrics[0].data[0].baseValueforLSorIs
                )
              )})
               </span>
                </div>
              </div>`: ``
              let power = (mdsdata.find((d: any) => d.submetricName == "Brand Power")) ? ` <div style="display: flex; align-items: center;margin-bottom:4%;">
                <div style="width: 25px; height: 5px; background-color: #f3eaff; border-radius: 50%; display: flex; justify-content: center; align-items: center; margin-right: 10px;">
                  <img src="/assets/images/common/BrandPower_icon.svg" alt="icon" style="width: 24px; height: 24px;">
                </div>
                <div style="display: flex; flex-direction: column;min-width:85px">
                  <div style="font-size: 0.6rem; color: #333; font-weight: 500;">Brand Power</div>
                  <div style="font-size: 0.6rem; color: #000; font-weight: 700;">${configService.CheckLSorIScondition(configService.userRole, Number.parseFloat(mdsdata.find((d: any) => d.submetricName == "Brand Power").metricSelected.metrics[0].data[0].data).toFixed(chartproperties.decimalRoundOff).toString(), Number(mdsdata.find((d: any) => d.submetricName == "Brand Power").metricSelected.metrics[0].data[0].baseValueforLSorIs))}
                  <span style="color: ${configService.CheckIndexColoring(Number.parseFloat(
                mdsdata.find((d: any) => d.submetricName == "Brand Power").metricSelected.metrics[0].data[0].data2
              ).toFixed(chartproperties.decimalRoundOff).toString())};">
                  (${configService.CheckLSorIScondition(configService.userRole, Number.parseFloat(mdsdata.find((d: any) => d.submetricName == "Brand Power").metricSelected.metrics[0].data[0].data2).toFixed(chartproperties.decimalRoundOff).toString(), Number(mdsdata.find((d: any) => d.submetricName == "Brand Power").metricSelected.metrics[0].data[0].baseValueforLSorIs))})
</span>
                  </div>
                </div>
              </div>`: ``
              let meaningful = (mdsdata.find((d: any) => d.submetricName == "Meaningful")) ? `<div style="display: flex; align-items: center;margin-bottom:4%;">
                <div style="width: 25px; height: 5px; background-color: #f3eaff; border-radius: 50%; display: flex; justify-content: center; align-items: center; margin-right: 10px;">
                  <img src="/assets/images/common/Meaningful_icon.svg" alt="icon" style="width: 24px; height: 24px;">
                </div>
                <div style="display: flex; flex-direction: column;min-width:85px">
                  <div style="font-size: 0.6rem; color: #333; font-weight: 500;">Meaningful</div>
                  <div style="font-size: 0.6rem; color: #000; font-weight: 700;">${configService.CheckLSorIScondition(configService.userRole, Number.parseFloat(mdsdata.find((d: any) => d.submetricName == "Meaningful").metricSelected.metrics[0].data[0].data).toFixed(chartproperties.decimalRoundOff).toString(), Number(mdsdata.find((d: any) => d.submetricName == "Meaningful").metricSelected.metrics[0].data[0].baseValueforLSorIs))}
                  <span style="color: ${configService.CheckIndexColoring(Number.parseFloat(
                mdsdata.find((d: any) => d.submetricName == "Meaningful").metricSelected.metrics[0].data[0].data2
              ).toFixed(chartproperties.decimalRoundOff).toString())};">
                  (${configService.CheckLSorIScondition(configService.userRole, Number.parseFloat(mdsdata.find((d: any) => d.submetricName == "Meaningful").metricSelected.metrics[0].data[0].data2).toFixed(chartproperties.decimalRoundOff).toString(), Number(mdsdata.find((d: any) => d.submetricName == "Meaningful").metricSelected.metrics[0].data[0].baseValueforLSorIs))})
</span>
                  </div>
                </div></div>`: ``;
              let diferent = (mdsdata.find((d: any) => d.submetricName == "Different")) ? ` <div style="display: flex; align-items: center;margin-bottom:4%;">
                <div style="width: 25px; height: 5px; background-color: #f3eaff; border-radius: 50%; display: flex; justify-content: center; align-items: center; margin-right: 10px;">
                  <img src="/assets/images/common/Different_icon.svg" alt="icon" style="width: 24px; height: 24px;">
                </div>
                <div style="display: flex; flex-direction: column;min-width:85px">
                  <div style="font-size: 0.6rem; color: #333; font-weight: 500;">Different</div>
                  <div style="font-size: 0.6rem; color: #000; font-weight: 700;">${configService.CheckLSorIScondition(configService.userRole, Number.parseFloat(mdsdata.find((d: any) => d.submetricName == "Different").metricSelected.metrics[0].data[0].data).toFixed(chartproperties.decimalRoundOff).toString(), Number(mdsdata.find((d: any) => d.submetricName == "Different").metricSelected.metrics[0].data[0].baseValueforLSorIs))}
                  <span style="color: ${configService.CheckIndexColoring(Number.parseFloat(
                mdsdata.find((d: any) => d.submetricName == "Different").metricSelected.metrics[0].data[0].data2
              ).toFixed(chartproperties.decimalRoundOff).toString())};">
                  (${configService.CheckLSorIScondition(configService.userRole, Number.parseFloat(mdsdata.find((d: any) => d.submetricName == "Different").metricSelected.metrics[0].data[0].data2).toFixed(chartproperties.decimalRoundOff).toString(), Number(mdsdata.find((d: any) => d.submetricName == "Different").metricSelected.metrics[0].data[0].baseValueforLSorIs))})
</span>
                
                  </div>
                </div>
              </div>`: ``
              let salience = (mdsdata.find((d: any) => d.submetricName == "Salience")) ? `<div style="display: flex; align-items: center;margin-bottom:4%;">
                <div style="width: 25px; height: 5px; background-color: #f3eaff; border-radius: 50%; display: flex; justify-content: center; align-items: center; margin-right: 10px;">
                  <img src="/assets/images/common/Salient_icon.svg" alt="icon" style="width: 24px; height: 24px;">
                </div>
                <div style="display: flex; flex-direction: column;min-width:85px">
                  <div style="font-size: 0.6rem; color: #333; font-weight: 500;">Salient</div>
                  <div style="font-size: 0.6rem; color: #000; font-weight: 700;">${configService.CheckLSorIScondition(configService.userRole, Number.parseFloat(mdsdata.find((d: any) => d.submetricName == "Salience").metricSelected.metrics[0].data[0].data).toFixed(chartproperties.decimalRoundOff).toString(), Number(mdsdata.find((d: any) => d.submetricName == "Salience").metricSelected.metrics[0].data[0].baseValueforLSorIs))}
                  <span style="color: ${configService.CheckIndexColoring(Number.parseFloat(
                mdsdata.find((d: any) => d.submetricName == "Salience").metricSelected.metrics[0].data[0].data2
              ).toFixed(chartproperties.decimalRoundOff).toString())};">
                  (${configService.CheckLSorIScondition(configService.userRole, Number.parseFloat(mdsdata.find((d: any) => d.submetricName == "Salience").metricSelected.metrics[0].data[0].data2).toFixed(chartproperties.decimalRoundOff).toString(), Number(mdsdata.find((d: any) => d.submetricName == "Salience").metricSelected.metrics[0].data[0].baseValueforLSorIs))})
                  </span>
                  </div>
                </div>
              </div>
              </div>`: ``
              let customLegend = `${premium}
               ${power}
               ${meaningful}
               ${diferent}
               ${salience}
              `;

              return customLegend;
            } else {
              let textCheck: any;
              const brandPremiumMetric = mdsdata.find((d: any) => d.submetricName === "Brand Premium");
              const brandPowerMetric = mdsdata.find((d: any) => d.submetricName === "Brand Power");
              const brandMeaningfulMetric = mdsdata.find((d: any) => d.submetricName === "Meaningful");
              const brandDifferentMetric = mdsdata.find((d: any) => d.submetricName === "Different");
              const brandSalientMetric = mdsdata.find((d: any) => d.submetricName === "Salience");

              textCheck = brandPremiumMetric ? configService.CheckLSorIScondition(configService.userRole, Number.parseFloat(mdsdata.find((d: any) => d.submetricName == "Brand Premium").metricSelected.metrics[0].data[0].data).toFixed(chartproperties.decimalRoundOff).toString(), Number(mdsdata.find((d: any) => d.submetricName == "Brand Premium").metricSelected.metrics[0].data[0].baseValueforLSorIs)) : '';

              let premium = (mdsdata.find((d: any) => d.submetricName == "Brand Premium")) ? `<div style="display:flex;align-items: center;justify-content:center;flex-direction:column;height:100%;margin-top:5%;">
              <div style="display: flex; align-items: center;margin-bottom:4%;">
                <div style="width: 25px; height: 5px; background-color: #f3eaff; border-radius: 50%; display: flex; justify-content: center; align-items: center; margin-right: 10px;">
                  <img src="/assets/images/common/PremiumIndex_icon.svg" alt="icon" style="width: 24px; height: 24px;">
                </div>
                <div style="display: flex; flex-direction: column;min-width:85px">
                  <div style="font-size: 0.6rem; color: #333; font-weight: 500;">Premium Index</div>
                  <div style="font-size: 0.6rem; color: #000; font-weight: 700;">${configService.CheckLSorIScondition(configService.userRole, Number.parseFloat(mdsdata.find((d: any) => d.submetricName == "Brand Premium").metricSelected.metrics[0].data[0].data).toFixed(chartproperties.decimalRoundOff).toString(), Number(mdsdata.find((d: any) => d.submetricName == "Brand Premium").metricSelected.metrics[0].data[0].baseValueforLSorIs))}
                       ${configService.sigChangeCheck(mdsdata.find((d: any) => d.submetricName == "Brand Premium").metricSelected.metrics[0].data[0], chartmaindata, textCheck)}
                  </div>
                </div>
              </div>`: ``;

              textCheck = brandPowerMetric ? configService.CheckLSorIScondition(configService.userRole, Number.parseFloat(mdsdata.find((d: any) => d.submetricName == "Brand Power").metricSelected.metrics[0].data[0].data).toFixed(chartproperties.decimalRoundOff).toString(), Number(mdsdata.find((d: any) => d.submetricName == "Brand Power").metricSelected.metrics[0].data[0].baseValueforLSorIs)) : '';

              let power = (mdsdata.find((d: any) => d.submetricName == "Brand Power")) ? ` <div style="display: flex; align-items: center;margin-bottom:4%;">
                <div style="width: 25px; height: 5px; background-color: #f3eaff; border-radius: 50%; display: flex; justify-content: center; align-items: center; margin-right: 10px;">
                  <img src="/assets/images/common/BrandPower_icon.svg" alt="icon" style="width: 24px; height: 24px;">
                </div>
                <div style="display: flex; flex-direction: column;min-width:85px">
                  <div style="font-size: 0.6rem; color: #333; font-weight: 500;">Brand Power</div>
                  <div style="font-size: 0.6rem; color: #000; font-weight: 700;">${configService.CheckLSorIScondition(configService.userRole, Number.parseFloat(mdsdata.find((d: any) => d.submetricName == "Brand Power").metricSelected.metrics[0].data[0].data).toFixed(chartproperties.decimalRoundOff).toString(), Number(mdsdata.find((d: any) => d.submetricName == "Brand Power").metricSelected.metrics[0].data[0].baseValueforLSorIs))}
                       ${configService.sigChangeCheck(mdsdata.find((d: any) => d.submetricName == "Brand Power").metricSelected.metrics[0].data[0], chartmaindata, textCheck)}
                  </div>
                </div>
              </div>`: ``;

              textCheck = brandMeaningfulMetric ? configService.CheckLSorIScondition(configService.userRole, Number.parseFloat(mdsdata.find((d: any) => d.submetricName == "Meaningful").metricSelected.metrics[0].data[0].data).toFixed(chartproperties.decimalRoundOff).toString(), Number(mdsdata.find((d: any) => d.submetricName == "Meaningful").metricSelected.metrics[0].data[0].baseValueforLSorIs)) : '';

              let meaningful = (mdsdata.find((d: any) => d.submetricName == "Meaningful")) ? `<div style="display: flex; align-items: center;margin-bottom:4%;">
                <div style="width: 25px; height: 5px; background-color: #f3eaff; border-radius: 50%; display: flex; justify-content: center; align-items: center; margin-right: 10px;">
                  <img src="/assets/images/common/Meaningful_icon.svg" alt="icon" style="width: 24px; height: 24px;">
                </div>
                <div style="display: flex; flex-direction: column;min-width:85px">
                  <div style="font-size: 0.6rem; color: #333; font-weight: 500;">Meaningful</div>
                  <div style="font-size: 0.6rem; color: #000; font-weight: 700;">${configService.CheckLSorIScondition(configService.userRole, Number.parseFloat(mdsdata.find((d: any) => d.submetricName == "Meaningful").metricSelected.metrics[0].data[0].data).toFixed(chartproperties.decimalRoundOff).toString(), Number(mdsdata.find((d: any) => d.submetricName == "Meaningful").metricSelected.metrics[0].data[0].baseValueforLSorIs))}
                  ${configService.sigChangeCheck(mdsdata.find((d: any) => d.submetricName == "Meaningful").metricSelected.metrics[0].data[0], chartmaindata, textCheck)}
                  </div>
                </div></div>`: ``;

              textCheck = brandDifferentMetric ? configService.CheckLSorIScondition(configService.userRole, Number.parseFloat(mdsdata.find((d: any) => d.submetricName == "Different").metricSelected.metrics[0].data[0].data).toFixed(chartproperties.decimalRoundOff).toString(), Number(mdsdata.find((d: any) => d.submetricName == "Different").metricSelected.metrics[0].data[0].baseValueforLSorIs)) : '';

              let diferent = (mdsdata.find((d: any) => d.submetricName == "Different")) ? ` <div style="display: flex; align-items: center;margin-bottom:4%;">
                <div style="width: 25px; height: 5px; background-color: #f3eaff; border-radius: 50%; display: flex; justify-content: center; align-items: center; margin-right: 10px;">
                  <img src="/assets/images/common/Different_icon.svg" alt="icon" style="width: 24px; height: 24px;">
                </div>
                <div style="display: flex; flex-direction: column;min-width:85px">
                  <div style="font-size: 0.6rem; color: #333; font-weight: 500;">Different</div>
                  <div style="font-size: 0.6rem; color: #000; font-weight: 700;">${configService.CheckLSorIScondition(configService.userRole, Number.parseFloat(mdsdata.find((d: any) => d.submetricName == "Different").metricSelected.metrics[0].data[0].data).toFixed(chartproperties.decimalRoundOff).toString(), Number(mdsdata.find((d: any) => d.submetricName == "Different").metricSelected.metrics[0].data[0].baseValueforLSorIs))}
                  ${configService.sigChangeCheck(mdsdata.find((d: any) => d.submetricName == "Different").metricSelected.metrics[0].data[0], chartmaindata, textCheck)}
                </div>
                </div>
              </div>`: ``;

              textCheck = brandSalientMetric ? configService.CheckLSorIScondition(configService.userRole, Number.parseFloat(mdsdata.find((d: any) => d.submetricName == "Salience").metricSelected.metrics[0].data[0].data).toFixed(chartproperties.decimalRoundOff).toString(), Number(mdsdata.find((d: any) => d.submetricName == "Salience").metricSelected.metrics[0].data[0].baseValueforLSorIs)) : '';

              let salience = (mdsdata.find((d: any) => d.submetricName == "Salience")) ? `<div style="display: flex; align-items: center;margin-bottom:4%;">
                <div style="width: 25px; height: 5px; background-color: #f3eaff; border-radius: 50%; display: flex; justify-content: center; align-items: center; margin-right: 10px;">
                  <img src="/assets/images/common/Salient_icon.svg" alt="icon" style="width: 24px; height: 24px;">
                </div>
                <div style="display: flex; flex-direction: column;min-width:85px">
                  <div style="font-size: 0.6rem; color: #333; font-weight: 500;">Salient</div>
                  <div style="font-size: 0.6rem; color: #000; font-weight: 700;">${configService.CheckLSorIScondition(configService.userRole, Number.parseFloat(mdsdata.find((d: any) => d.submetricName == "Salience").metricSelected.metrics[0].data[0].data).toFixed(chartproperties.decimalRoundOff).toString(), Number(mdsdata.find((d: any) => d.submetricName == "Salience").metricSelected.metrics[0].data[0].baseValueforLSorIs))}
                  ${configService.sigChangeCheck(mdsdata.find((d: any) => d.submetricName == "Salience").metricSelected.metrics[0].data[0], chartmaindata, textCheck)}
                  </div>
                </div>
              </div>
              </div>`: ``
              let customLegend = `${premium}
               ${power}
               ${meaningful}
               ${diferent}
               ${salience}
              `;

              return customLegend;
            }

          }
          else if (i < limit) {
            i++
          }
          else {
            i = 1
          };
          
          // return "text"
        },
      },
      tooltip: {
        enabled: true,
        borderWidth: 0,
        useHTML: true,
        shape: chartproperties.toolTipStyle == "style1" ? 'square' : 'callout',
        shadow: false,
        backgroundColor: 'rgba(0,0,0,0)',


        formatter: function (this: any): any {
          const pointWithMetric = this.point as {
            name?: any;
            parent?: any;
            color?: any;
            actualcolor?: any;
            y?: number;
            y1?: number;
            cov?: string;
            significance?: string;
            significance2?: string;
            samplesize?: number;
            tooltip?: any;
            isPercentage?: any;
            Significance_Value?: any;
          };
          const backgroundcolor = chartproperties.darkTheme ? '#b3b3b3' : '#f5f5f5';
          const backgroundcolor2 = chartproperties.darkTheme ? '#dddddd' : 'white';
          if (pointWithMetric.tooltip == "") { pointWithMetric.tooltip = pointWithMetric.y1 == null ? 'NA' : pointWithMetric.y }

          let isDefaultTooltip = chartproperties.toolTipStyle;
          if (isDefaultTooltip == "style1") {
            const dotColor = pointWithMetric.actualcolor;
            const commonContent =
              `<div style="border-left: 2px solid ` + dotColor + `; border-bottom: 2px solid ` + dotColor + `; z-index: 100; padding: 5px; border-radius: 5px; margin: 0px; background-color :${backgroundcolor2};">` +
              // `<span style="display: block; text-align: center; color: ` + dotColor + `; font-weight: bold; font-size: 12px;">Tooltip Title</span>` +
              // `<span><strong>Series Name:</strong></span>Brands<br>` +
              `${pointWithMetric.name} : ` +
              `${pointWithMetric.tooltip}`;
            return commonContent + '</div>';
          }
          else {
            const dotColor = pointWithMetric.actualcolor; // Get the series color

            const content =
              `<div style="background-color: ${backgroundcolor}; padding: 5px; align-items: center; border: 1px solid ${dotColor}; ">` +
              `<div style="width: 10px; height: 10px; background-color: ${dotColor}; border-radius: 50%; margin-right: 5px;"><div style="padding-left:10px;margin-top:0">${pointWithMetric.name}</div></div>` +
              `<div style="display: block; margin-top: 5px;"><strong>Value:</strong> ${pointWithMetric.tooltip}</div>`;

            return content + '</div>';

          }



        },
      },
      plotOptions: {
        allowPointSelect: false,
        series: {
          allowPointSelect: false,
          states: {
            hover: {
              enabled: false
            },
            inactive: {
              enabled: false
            },
            select: {
              enabled: false
            }
          }
        },
        variablepie: {
          showInLegend: chartproperties.showLegend,
          borderWidth: chartproperties.border ? 2 : 0,
          borderColor: chartproperties.darkTheme ? 'white' : 'black',
          innerSize: this.height != "100%" ? 60 : 150,
          depth: 1,
          shadow: chartproperties.shadow ? {
            color: 'rgba(0, 0, 0, 0.5)',
            offsetX: 1,
            offsetY: 1,
            opacity: 0.5,
            width: 6,
          } : false,
          dataLabels: {
            style: {
              textOutline: 'none',
              fontSize: chartproperties.dataLabelSize,
              fontWeight: "normal"
            },
            enabled: chartproperties.showDataLabel,
            color: chartproperties.dataLabelColor == "default" ? (chartproperties.darkTheme ? 'white' : 'black') : chartproperties.dataLabelColor,
            connectorWidth: chartproperties.connector ? 1 : -0,
            connectorColor: null,
            connectorPadding: 0,
            distance: chartproperties.connector ? 10 : 0,
            useHtml: true,
            formatter: function (this: Highcharts.TooltipFormatterContextObject): any {
              const pointWithMetric = this.point as {
                name?: any;
                parent?: any;
                color?: any;
                y?: number;
                y1?: number;
                cov?: string;
                significance?: string;
                samplesize?: number;
                significance2?: any;
                tooltip?: any;
                isPercentage?: any;
                Significance_Value?: any;
                indexValue?: any
              };
              let textcolor = chartproperties.darkTheme ? 'white' : 'black';
              if (chartproperties.datalabelStyle === "index") {

                let text = pointWithMetric.y1 != null ? pointWithMetric.y + (pointWithMetric.isPercentage ? '%' : '') : "NA";
                text = configService.CheckLSorIScondition(configService.userRole, text, Number(pointWithMetric.samplesize));

                // let text2 = pointWithMetric.y1 == 0 ? 'NA' :pointWithMetric.y1 == -1 ? -1 : pointWithMetric.indexValue != null ? pointWithMetric.indexValue.toFixed(1) : 'NA';
                // if (text2 == "-1" || text2 == -1) {
                //   text2 = "NA";
                // }
                // text2 = configService.CheckLSorIScondition(configService.userRole, String(text2), Number(pointWithMetric.samplesize));
                // let color = configService.CheckIndexColoring(String(text2));
                // pointWithMetric.tooltip = text+"("+text2+")";
                pointWithMetric.tooltip = text;
                // return (
                //   '<span style="font-size:0.5rem;">' + text + '</span>' +
                //   '<span style="color:' + color + ';font-size:0.45rem;">' + " " + '(' + text2 + ')</span>'
                // );
                return (
                  '<span style="font-size:0.5rem;">' + text + '</span>' 
                );
                
              }
              else if (chartproperties.datalabelStyle === 'datalabel' || chartproperties.datalabelStyle === 'sigChange') {
                let text = pointWithMetric.y1 != null ? pointWithMetric.y + (pointWithMetric.isPercentage ? '%' : '') : "NA";
                text = configService.CheckLSorIScondition(configService.userRole, text, Number(pointWithMetric.samplesize));
                pointWithMetric.tooltip = text;
                return (
                  '<span style="display: inline-block;padding:3px;">' +
                  text +
                  '</span>'
                );
              }
              else if (chartproperties.datalabelStyle === 'change') {
                let text = pointWithMetric.y1 != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') + ' ' + `<span span style="font-size: 80%;color:` + (chartproperties.darkTheme ? 'white' : 'black') + `">(` + (Number(pointWithMetric.cov) > 0 ? '+' : '') + `${pointWithMetric.cov} )</span>` : 'NA';
                pointWithMetric.tooltip = text;
                return (
                  '<span style:"color:' + textcolor + ';">' + text + '</span>'
                );
              } else if (chartproperties.datalabelStyle === 'significance + changeVs') {
                const upwardTriangle = '\u25B2';
                const downwardTriangle = '\u25BC';
                let sig = Number(pointWithMetric.significance);
                let s =
                  sig > 0 ? upwardTriangle : sig < 0 ? downwardTriangle : '';
                let sigcolor = sig > 0 ? 'green' : sig < 0 ? 'red' : '';
                let text = pointWithMetric.y1 != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') + ' ' + `<span span style="font-size: 80%;color:` + (chartproperties.darkTheme ? 'white' : 'black') + `">(` + (Number(pointWithMetric.cov) > 0 ? '+' : '') + `${pointWithMetric.cov} )</span>` + '<span style="color:' +
                  sigcolor +
                  ';">' +
                  s +
                  '</span>' : 'NA';
                pointWithMetric.tooltip = text;
                return (
                  '<span style:"color:' +
                  textcolor +
                  ';">' +
                  text +
                  '</span>'
                );
              } else if (chartproperties.datalabelStyle === 'significance') {
                const upwardTriangle = '\u25B2';
                const downwardTriangle = '\u25BC';
                let sig = Number(pointWithMetric.significance);
                let s =
                  sig > 0 ? upwardTriangle : sig < 0 ? downwardTriangle : '';
                let sigcolor = sig > 0 ? 'green' : sig < 0 ? 'red' : '';
                let text = pointWithMetric.y1 != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') + '<span style="color:' +
                  sigcolor +
                  ';">' +
                  s +
                  '</span>' : 'NA';
                pointWithMetric.tooltip = text;
                return (
                  '<span style:"color:' +
                  textcolor +
                  ';">' +
                  text +
                  '</span>'
                );
              } else if (chartproperties.datalabelStyle === 'ls') {
                let text = Number(pointWithMetric.samplesize) > samplesizeconstant ? (pointWithMetric.y1 == null || pointWithMetric.y == 0 ? 'NA' : pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '')) : 'LS';
                return (
                  '<span style="display: inline-block;padding:3px;">' +
                  text +
                  '</span>'
                );
                pointWithMetric.tooltip = text;
              } else if (chartproperties.datalabelStyle == "significance2") {
                const upwardTriangle = '\u25B2';
                const downwardTriangle = '\u25BC';
                let text = pointWithMetric.y1 != null ? this.y + (chartproperties.dataLabelFormat ? '%' : '') : 'NA';
                let changeText = pointWithMetric.cov;
                let sig = pointWithMetric.significance;
                let sig1 = pointWithMetric.significance2;
                let sColor = Number(sig) > 0 ? 'green' : (Number(sig) < 0 ? 'red' : '');
                let s = Number(sig) > 0 ? upwardTriangle : (Number(sig) < 0 ? downwardTriangle : '');
                let changeColor = sig1 < 0 ? 'red' : (sig1 > 0 ? 'green' : (chartproperties.darkTheme ? 'white' : 'black'));
                c++;

                if (Number(changeText) > 0) {
                  changeText = "+" + changeText;
                }
                let text1 = '<span>' + text +
                  (pointWithMetric.y1 != null && changeText ? '&nbsp<span style="color:' + ';"> ' +
                    '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span> &nbsp' +
                    '<span style="color:' + sColor + ';">' + s + '</span>' : '') +
                  '</span>'
                pointWithMetric.tooltip = text1;
                return (
                  text1
                );
              }
            },
            connectorDashStyle: 'dashed',
          },

        }
      },
      series: this.seriesdata,
      credits: {
        enabled: false
      },
      exporting: {
        enabled: false
      }
    } as any,
    );

  }
  applycustomization(event: any, item: string) {
    //choose the appropriate customization
    this.piechartservice.applycustomization(event, item, this.chartproperties)
    this.plotChart('chart-container', this.jsondata['data'], this.chartproperties);
  }
  userselectedproperties() {
    // this.jsondata['data']=this.jsondata['data'].slice(0,10);
    this.jsondata['properties'][0] = this.chartproperties;
    return JSON.stringify(this.jsondata).toString();
  }

  ngOnDestroy(): void {
    // Unsubscribe to prevent memory leaks and unnecessary reloads
    this.subscriptions.unsubscribe();
  }
}
